import { Component, OnInit,Input,Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription} from 'rxjs';
import { LogoService } from '../../services/logo.service';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faDollarSign,faBan, faArrowUp, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { faCircle} from '@fortawesome/free-regular-svg-icons';
@Component({
  selector: 'app-entity-new',
  templateUrl: './entity-new.component.html',
  styleUrls: ['./entity-new.component.scss']
})
export class EntityNewComponent implements OnInit, OnChanges {

  private logosData$: Subscription;
  logosData:any;

  @Input() data;
  @Input() viewType="landscape"
  @Input() pageView = 0;
  @Output() edit = new EventEmitter<boolean>();
  
  statusColor: any = '';
  trendColor: any = '';
  primaryTechnology: any = '';
  primaryTechnologyImage: any = '';
  secondaryTechnology: any = '';
  secondaryTechnologyImage: any = '';
  provider: any = '';
  providerImage: any = '';

  prevStatus = '';
  prevHealthTrend = '';
  prevPrimaryTechnology = '';
  prevSecondaryTechnology = '';
  prevProvider = '';

  constructor(
    public logoService: LogoService,
    library: FaIconLibrary,
  ) { 
    library.addIcons(faDollarSign,faBan,faCircle,faArrowUp, faQuestion);
  }

  ngOnInit(): void {

        // wire up the logos - this will get loaded by the main page
        // so aren't doing for every entity
        this.logosData$ = this.logoService.logos$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){                  
              if(responsedata.loading){
              } else {
                this.logosData = responsedata["data"];      
              }          
            }
          }
        )

    this.initData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const viewTypeChange = changes['viewType'];
    if (viewTypeChange && !viewTypeChange.firstChange) {
      this.initData();
    }

    const dataChange = changes['data'];
    if (dataChange && !dataChange.firstChange) {
      const {
        currentValue: {
          status,
          healthstatus,
          healthtrend,
          primarytechnology,
          secondarytechnology,
          provider
        }
      } = dataChange;

      let curStatus = '';
      if (this.viewType === 'landscape') {
        curStatus = status;
      } else if (this.viewType === 'health') {
        curStatus = healthstatus;
      }
      if (this.prevStatus !== curStatus) {
        this.setStatusColor();
      }
      if (this.prevHealthTrend !== healthtrend) {
        this.setTrendColor();
      }
      if (this.prevPrimaryTechnology !== primarytechnology) {
        this.setPrimaryTechnology();
      }
      if (this.prevSecondaryTechnology !== secondarytechnology) {
        this.setSecondaryTechnology();
      }
      if (this.prevProvider !== provider) {
        this.setProvider();
      }
    }
  }

  initData() {
    if (this.data) {
      this.setStatusColor();
      this.setTrendColor();
      this.setPrimaryTechnology();
      this.setSecondaryTechnology();
      this.setProvider();
    }
  }

  getStatusColor(val){

   /*
   if(val=="DXC Engagement") return "#97BE35"
   if(val=="DXC Opportunity") return "#F7CF2B"
   if(val=="DXC Lost or Not Engaged") return "#FF0000"
   if(val=="Strategic Program Target") return "#1870B9"
   if(val=="Unknown Status") return "#A3A3A3"
   */

   if(val=="Existing Business") return "#97BE35"
   if(val=="Potential Growth") return "#F7CF2B"
   if(val=="Not Engaged") return "#FF0000"
   if(val=="Unknown Status") return "#A3A3A3"

   if(val=="Healthy") return "#27C88F"
   if(val=="Borderline") return "#F7CF2B"
   if(val=="Critical Improvement Needed") return "#FF0000"
   if(val=="Strategic Growth Program") return "#1870B9"
   if(val=="Unknown Status") return "#A3A3A3"

    return ""    
  }

  providerIsImage(val){    
    if(val==undefined || val==null) return false;

    // if the entity is "client" then use the logo if it is defined    
    if(val.toLowerCase()=="client"){
      val = this.data.clientlogo ? this.data.clientlogo : "Client";
    }
    if(val=="Client") return false;
    

    if(this.logosData.filter(x => (x.name.toLowerCase() == val.toLowerCase())).length>0){
      return true;
    } else {
      return false;
    }
  }

  providerGetImage(val){    
    if(val==undefined || val==null) return false;

    // if the entity is "client" then use the logo if it is defined   
    let p = val; 
    if(val.toLowerCase()=="client"){
      p = this.data.clientlogo ? this.data.clientlogo : "Client";
    }

    let logo = this.logosData.filter(x => (x.name.toLowerCase() == p.toLowerCase()))
    if(logo.length>0){
      return "/logos/" +  logo[0].file;
    } else {
      return "";
    }
  }

  fmtPrc(x){
    if(x===0){
      return "0%"
    }
    else if(x==null || x=="") {
      return ""
    } else {
      return x + "%";
    }

  }

  editEntity(){    
    this.edit.emit(this.data.id)
  }

  getTrendColor(val) {
    let color = '';
    switch (val) {
      case 'Will Improve':
      case 'Will Maintain Healthy':
        color = '#27C88F';
        break;
      case 'Will Degrade':
        color = '#F7CF2B';
        break;
      case 'Is Actively Degrading':
        color = '#FF0000';
        break;
      case 'Unknown Status':
        color = '#6E6E6E';
        break;
      default:
        break;
    }
 
    return color;
  }

  setStatusColor() {
    let status = '';
    if (this.viewType === 'landscape') {
      status = this.data.status;
    } else if (this.viewType === 'health') {
      status = this.data.healthstatus;
    }

    this.prevStatus = status;
    this.statusColor = this.getStatusColor(status);
  }

  setTrendColor() {
    this.prevHealthTrend = this.data.healthtrend;
    this.trendColor = this.getTrendColor(this.data.healthtrend);
  }

  setTechnologyProvider(dataKey: string, key: string) {
    const isImage = this.providerIsImage(this.data[dataKey]);
    const imageKey = `${key}Image`;
    if (isImage) {
      this[imageKey] = this.providerGetImage(this.data[dataKey]);
      this[key] = '';
    } else {
      this[imageKey] = '';
      this[key] = this.data[dataKey] && this.data[dataKey].toLowerCase() === 'client' ? 'Client' : this.data[dataKey];
    }
  }

  setPrimaryTechnology() {
    this.prevPrimaryTechnology = this.data.primarytechnology;
    this.setTechnologyProvider('primarytechnology', 'primaryTechnology');
  }

  setSecondaryTechnology() {
    this.prevSecondaryTechnology = this.data.secondarytechnology;
    this.setTechnologyProvider('secondarytechnology', 'secondaryTechnology');
  }

  setProvider() {
    this.prevProvider = this.data.provider;
    this.setTechnologyProvider('provider', 'provider');
  }
}


